import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nProvider } from './i18n';
import { MuseApp } from './App';
import { ErrorBoundary } from './ErrorBoundary';
import './styles/tokens.css';
import './styles/app.css';

// Sovereign MUSE — single-user bearer-auth app.
// No router: we render the studio directly. The token modal inside MuseApp
// handles unauthenticated state. No landing page, no login flow, no billing.

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <I18nProvider>
        <MuseApp />
      </I18nProvider>
    </ErrorBoundary>
  </StrictMode>,
);
